var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "waba-supsis-template-category-update" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(
        _vm._s(_vm.$t("auto.whatsappBusinessApiV2TemplateCategoryUpdated"))
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "meta" }, [
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.templateName")))]),
        _vm._v(
          ": " +
            _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_name"))
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.templateId")))]),
        _vm._v(
          ": " + _vm._s(_vm.$_.get(_vm.activity, "payload.message_template_id"))
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.language")))]),
        _vm._v(
          ": " +
            _vm._s(
              _vm.$_.get(_vm.activity, "payload.message_template_language")
            )
        ),
      ]),
      _vm._v(" "),
      _vm.$_.get(_vm.activity, "payload.previous_category")
        ? _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.$t("auto.previousCategory")))]),
            _vm._v(
              ": " +
                _vm._s(_vm.$_.get(_vm.activity, "payload.previous_category")) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$_.get(_vm.activity, "payload.new_category")
        ? _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.$t("auto.newCategory")))]),
            _vm._v(
              ": " +
                _vm._s(_vm.$_.get(_vm.activity, "payload.new_category")) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$_.get(_vm.activity, "payload.correct_category")
        ? _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.$t("auto.correctCategory")))]),
            _vm._v(
              ": " +
                _vm._s(_vm.$_.get(_vm.activity, "payload.correct_category")) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$_.get(_vm.activity, "payload.category_update_timestamp")
        ? _c("div", [
            _c("b", [_vm._v(_vm._s(_vm.$t("auto.updateTime")))]),
            _vm._v(
              ": " +
                _vm._s(
                  _vm.formatTimestamp(
                    _vm.$_.get(
                      _vm.activity,
                      "payload.category_update_timestamp"
                    )
                  )
                ) +
                "\n        "
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("details", { staticClass: "raw" }, [
      _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
      _vm._v(" "),
      _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }